  var firebaseConfig = {
    apiKey: "AIzaSyADLwIrKy9gaZpzMDFJ8TSoq8UodQ9Z-Wg",
    authDomain: "react-ranking.firebaseapp.com",
    databaseURL: "https://react-ranking.firebaseio.com",
    projectId: "react-ranking",
    storageBucket: "react-ranking.appspot.com",
    messagingSenderId: "777898632423",
    appId: "1:777898632423:web:85856147e982db94c2ee42",
    measurementId: "G-CSP4EQGK7L"
  };

export default firebaseConfig;
